
/** By using this  model object Server API (findByLoanPrimaryKey) called, server need list of unique ID  */
export class ArrayOfKeys {

  public keys: number[];
  constructor() {
    this.keys = null;
  }
}
